import { render } from "./VenueSidebar.vue?vue&type=template&id=0f6f3a64&scoped=true"
import script from "./VenueSidebar.vue?vue&type=script&lang=js"
export * from "./VenueSidebar.vue?vue&type=script&lang=js"

import "./VenueSidebar.vue?vue&type=style&index=0&id=0f6f3a64&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6f3a64"]])

export default __exports__